// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__VoyDH","footer":"NavbarSimple_footer__dmdbB","link":"NavbarSimple_link__zlWg1","linkIcon":"NavbarSimple_linkIcon__nc1HZ"};